<div bsModal #modal="bs-modal" class="modal patient-selfevaluation-modal fade" tabindex="-1" role="dialog" aria-hidden="false">
    <div *ngIf="!activeQuestionnaireId" class="modal-dialog">
        <ng-container *ngIf="!formLoading">
            <div class="modal-content">
                <div *ngIf="queryParams && queryParams['modalTitle']" class="modal-header modal-header--contact-email">
                    <span *ngIf="!queryParams['disableBack']" class="modal-header--goback" (click)="router.navigate(['/patients/edit/' + this.patientId] , {queryParams: { modalTitle: 'Update Patient', status: 'Activated' }})">
                        <i class="fas fa-arrow-left"></i>
                        {{ 'Back to Patient profile' | translate }}
                    </span>
                    <h4 class="modal-title">
                        {{ 'Contact patient' | translate }}
                    </h4>
                    <button type="button" class="btn btn-link fal fa-times close" (click)="hideModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body patient-form mat-form">
                    <form [formGroup]="form" class="mat-form" novalidate>
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-sm-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="successMessage" class="row form-group" role="alert">
                            <div class="alert alert-info">
                                {{ successMessage | translate }}
                            </div>
                        </div>
                        <div class="row">
                            <ng-container *ngFor="let contactType of CONTACTTypes">
                                <div *ngIf="!contactType.disabled" class="col-xs-4">
                                    <div class="se-type se-type--{{contactType.name}}"
                                         [class.active]="contactType.type === activeCONTACTType.type"
                                         (click)="changecontactType(contactType.type)">
                                        <span class="se-type--label">{{ contactType.createTitle | translate }}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!--    START QUESTIONNAIRE -->
                        <ng-container>
                            <div class="row mr-t--md">
                                <div class="form-group col-xs-8">
                                    <mat-form-field class="ps-content">
                                        <input type="email" matInput required disabled [placeholder]="'Email Address' | translate" formControlName="email"/>
                                        <small class="form-text" [hidden]="form.controls.email.valid ||
                                                (form.controls.email.pristine && !formSubmitted) ||
                                                form.controls.email.disabled">
                                            {{ 'Require this format: name@company.com' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>

                            <ng-container *ngIf="bookingTemplate">
                                <div class="row" *ngFor="let contactType of CONTACTTypes" [hidden]="activeCONTACTType.type !== contactType.type">
                                    <label class="form-group col-xs-12">{{ 'Message' | translate }}</label>
                                    <div class="col-xs-12" [disabled]="activeCONTACTType.type !== contactType.type">
                                        <app-tinymce #tinymce [(ngModel)]='emailsContent[contactType.type]' [ngModelOptions]="{standalone: true}">
                                        </app-tinymce>
                                    </div>
                                    <div class="form-group hidden">
                                        <input formControlName="email_subject" type="text"/>
                                    </div>
                                </div>
                            </ng-container>

                        </ng-container>
                        <!--  /END  START QUESTIONNAIRE -->

                        <div class="row mt-1">
                            <div class="col-xs-12 text-xs-left">
                                <button type="button" class="btn btn-primary" (click)="submit(form.value, form.valid)">
                                    {{ 'Send message' | translate }}
                                </button>
                                <button type="button" class="btn btn-secondary badge-pill" (click)="hideModal()">
                                    {{ 'Cancel' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<dialog-component #dialog></dialog-component>